export const LIST_TINY = 'LIST_TINY';
export const NEW_TINY = 'NEW_TINY';
export const DEL_TINY = 'DEL_TINY';
export const GET_TINY = 'GET_TINY';
export const EXIST_TINY = 'EXIST_TINY';
export const GET_ID = 'GET_ID';
